import { isEqual } from '@luminovo/commons';

export function arrayToggleItem<T>(array: Array<T>, value: T): Array<T> {
    const isFilterActive = array.some((item) => isEqual(item, value));

    if (isFilterActive) {
        return array.filter((item) => !isEqual(item, value));
    } else {
        return [...array, value];
    }
}

export function arrayToggleItems<T>(array: Array<T>, items: Array<T>): Array<T> {
    return items.reduce((acc, item) => arrayToggleItem(acc, item), array);
}
